import VideoValidado from "../../constructor/umas/Actividades/ActividadesUtils/RecursosValidados/VideoValidado";
import PlaceholderMedia from "../../constructor/umas/PlaceholderMedia";

export default function Video({ video, pieDeFoto, medidas, isGeneratingPDF = false }) {
  const reemplazarRecursos = new URLSearchParams(window.location.search).get('reemplazarRecursos') === 'true';

  // En modo PDF, mostrar placeholder
  if (isGeneratingPDF && video && video.includes(".mp4")) {
    return (
      <div className="w-full justify-center">
        <div className="my-10 mx-auto w-full max-w-[1280px]">
          <PlaceholderMedia 
            tipo="video" 
            nombreArchivo={reemplazarRecursos ? video : null} 
          />
          <div
            dangerouslySetInnerHTML={{ __html: pieDeFoto }}
            className="mt-2"
          ></div>
        </div>
      </div>
    );
  }

  return (
    <>
      {video && video.includes(".mp4") && (
        <div className="w-full justify-center">
          <div className="my-10 mx-auto w-full max-w-[1280px]">
            <div className="video_bg">
              <VideoValidado
                src={video}
                className="rounded-lg w-full border border-[#dcdcdc] aspect-video"
              />
            </div>
            <div
              dangerouslySetInnerHTML={{ __html: pieDeFoto }}
              className="mt-2"
            ></div>
          </div>
        </div>
      )}
    </>
  );
}
